import {
  PACKAGE_LIST,
  TOKEN_LIST,
  RECHARGE_MODAL,
  PURCHASE_MODAL,
  PURCHASE_TRANSACTION_LIST,
  USER_BALANCE,
  CONVERSION_RATE,
} from "@transactionaction";

export function packageList(state = {}, action) {
  if (action.type === PACKAGE_LIST) {
    return action.payload;
  }
  return state;
}

export function walletList(state = {}, action) {
  if (action.type === TOKEN_LIST) {
    return action.payload;
  }
  return state;
}

export function openRecharge(state = {}, action) {
  if (action.type === RECHARGE_MODAL) {
    return action.payload;
  }
  return state;
}

export function purchaseHistory(state = {}, action) {
  if (action.type === PURCHASE_MODAL) {
    return action.payload;
  }
  return state;
}

export function transactionList(state = {}, action) {
  if (action.type === PURCHASE_TRANSACTION_LIST) {
    return action.payload;
  }
  return state;
}

export function myBalance(state = {}, action) {
  if (action.type === USER_BALANCE) {
    return action.payload;
  }
  return state;
}

export function conversionRate(state = {}, action) {
  if (action.type === CONVERSION_RATE) {
    return action.payload;
  }
  return state;
}
